import { cn } from "@src/lib/utils";
import type { PromptInputBodyProps } from "./PromptInputBodyProps";

export const PromptInputBody = ({
  className,
  ...props
}: PromptInputBodyProps) => (
  <div className={cn("contents", className)} {...props} />
);
